import React from "react";

const LineArrow = () => {
    return (
        <>
            <svg
                width="182"
                height="5"
                xmlns="http://www.w3.org/2000/svg"
                overflow="hidden"
            >
                <defs>
                    <clipPath id="a">
                        <path d="M882 632h182v5H882z" />
                    </clipPath>
                </defs>
                <g clipPath="url(#a)" transform="translate(-882 -632)">
                    <path
                        d="M1063.67 636.223c-60.165-1.67-119.984-1.935-180.105.774-2.102.1-2.073-2.389 0-2.51 59.733-3.45 120.502-3.55 180.105 1.216.432.033.447.53 0 .52Z"
                        fill="#0066E2"
                    />
                </g>
            </svg>
        </>
    );
};

export default LineArrow;
